@defer (when issue()) {
  @if (dataTable()) {
    <app-data-table [dataTable]="dataTable()" (onRowClick)="rowClick($event)" />
  }
} @placeholder (minimum 100ms) {
  <i class="mdi mdi-loading mdi-spin-x2"></i>
}

@if (auditItem()) {
  <app-dialog [canScroll]="false" (onClose)="auditItem.set(null)" [dimensions]="{ width: 500, height: 270 }" header="Audit Item">
    <div class="mt-2 audit-message">{{ auditItem().message }}</div>
    <div class="mt-2">
      @if (issue().substatus_id > 5) {
        This issue has been completed
        @if (!issue().completedAt) {
          but has <b>no completed date</b>
        }
        .
        <app-button label="Update completed date using this audits date of '{{ auditItem().createdAt | date }}'" (click)="completeIssue()" />
      }
    </div>
  </app-dialog>
}
